import React from 'react';
import {
  Container,
  Typography,
  Box,
  Divider,
  List,
  ListItem,
  ListItemText,
  Paper,
  Button
} from '@mui/material';

const PrivacyPolicy = ({ data }) => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper elevation={0} sx={{ p: 3 }}>
        <Typography variant="h4" component="h2" gutterBottom align="center" sx={{ pb: 2, borderBottom: 1, borderColor: 'divider' }}>
          Privacy Policy
        </Typography>
        
        <Box sx={{ mb: 4 }}>
          <Typography paragraph>
            <strong><em>{localStorage.getItem('companyName')},</em></strong> referred to as <strong><em>"Company"</em></strong>, which term shall refer to and include its owners, directors, investors, employees or other related parties.
          </Typography>
          <Typography paragraph>
            While the Company has other products and services under separate terms and conditions not intersecting the ones here, this agreement includes the terms of use of the mobile application referred herein as <strong><em>"{localStorage.getItem('companyName')}"</em></strong>.
          </Typography>
          <Typography paragraph>
            Persons availing of the {localStorage.getItem('companyName')} Services, directly or indirectly, are referred to herein, as "Users".
          </Typography>
          <Typography paragraph>
            This is an agreement between {localStorage.getItem('companyName')} and User, which is binding and requires mandatory compliance by User. Integrity, honesty and ethical business practices are some of the core values for {localStorage.getItem('companyName')}. {localStorage.getItem('companyName')} strongly condemns any and all activities related to money laundering and such other illegal actions. In order to prevent misuse of the {localStorage.getItem('companyName')} Services, Users are required to strictly comply with the terms contained herein, which forms part and parcel of the User Terms of Service. Terms not defined herein shall carry the same interpretation, as in the User Agreement and in the absence thereof to general usage and parlance.
          </Typography>
          <Typography paragraph>
            Users are required to read, review, understand and then agree to the terms hereunder for using or availing of the {localStorage.getItem('companyName')} Services, before clicking the "I Accept" option.
          </Typography>
          <Typography paragraph>
            <strong><em>This Agreement supersedes and replaces any and all prior oral or written understandings or agreements between {localStorage.getItem('companyName')} and the User with respect to the Privacy Policy.</em></strong>
          </Typography>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Typography variant="h5" component="h3" gutterBottom>
          DEFINITIONS
        </Typography>
        <Box sx={{ mb: 4 }}>
          <Typography paragraph>
            All terms defined in the Terms of Service and the Anti-Money Laundering Policy will carry the same meaning, force and effect in this Privacy Policy.
          </Typography>
          <Typography paragraph>
            <strong>"Applicable Law"</strong> means the law in force for the time being within the territory of United States of America;
          </Typography>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Typography variant="h5" component="h3" gutterBottom>
          PRIVACY POLICY
        </Typography>
        <Box sx={{ mb: 4 }}>
          <Typography paragraph>
            (A) {localStorage.getItem('companyName')} is committed to ensuring the safety and protection of all data and information shared with {localStorage.getItem('companyName')} by its Users subject to Applicable Laws and the terms and conditions set out hereunder and processes established by {localStorage.getItem('companyName')} in compliance with the applicable reasonable security practices and procedures, prescribed by Government or Regulatory authorities, as the case may be.
          </Typography>
          <Typography paragraph>
            (B) {localStorage.getItem('companyName')} shall not be liable for any breach or violation of its systems or policies due to malicious attacks, errors, commissions or omissions not willfully initiated by {localStorage.getItem('companyName')}, leading to breach of data or information of User.
          </Typography>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Typography variant="h5" component="h3" gutterBottom>
          DATA COLLECTED
        </Typography>
        <Box sx={{ mb: 4 }}>
          <Typography paragraph>
            (A) {localStorage.getItem('companyName')} collects all personal data and information of the User including sensitive personal information. Use of the {localStorage.getItem('companyName')} services is contingent on acceptance of the terms contained herein. User shall be deemed to have volunteered the data and information collected, retained, used and disseminated by {localStorage.getItem('companyName')}, upon accepting the terms herein and those contained in the Terms of Service of {localStorage.getItem('companyName')}.
          </Typography>
          <Typography paragraph>
            (B) User hereby consents that when personal data is shared with {localStorage.getItem('companyName')}, User hereby agrees and acknowledges {localStorage.getItem('companyName')}'s right to use or disseminate such data or information including transfer of the personal and sensitive personal information of the User from current location to external sources including outside US and third parties.
          </Typography>
          <Typography paragraph>
            (C) {localStorage.getItem('companyName')} collects and retains data and information of user including the following:
          </Typography>
          <Typography component="div">
            <List dense>
              <ListItem>
                <ListItemText
                  primary="i. Information provided / shared by the User:"
                  secondary={`${localStorage.getItem('companyName')} collects any and all personal information provided by User to ${localStorage.getItem('companyName')}. This information may include that which is provided by the Users, at the time of opening an account and transacting with ${localStorage.getItem('companyName')} including the following:`}
                />
              </ListItem>
            </List>
            <List dense sx={{ pl: 4 }}>
              <ListItem>
                <ListItemText primary="a. Name" />
              </ListItem>
              <ListItem>
                <ListItemText primary="b. Residential Address" />
              </ListItem>
              <ListItem>
                <ListItemText primary="c. Registered Mobile Number" />
              </ListItem>
              <ListItem>
                <ListItemText primary="d. Email Address" />
              </ListItem>
              <ListItem>
                <ListItemText primary="e. Government issued ID" />
              </ListItem>
              <ListItem>
                <ListItemText primary="f. Bank Account Details" />
              </ListItem>
              <ListItem>
                <ListItemText primary="g. Any other information." />
              </ListItem>
            </List>
            <List dense>
              <ListItem>
                <ListItemText primary="ii. {localStorage.getItem('companyName')} may collect, retain, use or store data or information automatically collected from a device or through connections associated to such device, including but not limited to the following:" />
              </ListItem>
            </List>
            <List dense sx={{ pl: 4 }}>
              <ListItem>
                <ListItemText primary="a. User's device information including but not limited to IMEI or equipment identification number, IMSI or subscriber identification, MAC address, Android version, device details, network operator, contact list information, Wifi / Data Network connectivity." />
              </ListItem>
              <ListItem>
                <ListItemText primary="b. Information generated by the User's use of the app and the website, including cookies and IP addresses." />
              </ListItem>
              <ListItem>
                <ListItemText primary="c. Access to User's Photo Gallery / Media / Files / Camera;" />
              </ListItem>
              <ListItem>
                <ListItemText primary="d. Access to User's other apps and services including messaging through SMS; usage data;" />
              </ListItem>
              <ListItem>
                <ListItemText primary="e. Geolocation of a User's device or such or other automatically collated data or information of User." />
              </ListItem>
            </List>
          </Typography>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Typography variant="h5" component="h3" gutterBottom>
          PURPOSE & USE OF DATA COLLECTED
        </Typography>
        <Box sx={{ mb: 4 }}>
          <Typography paragraph>
            (A) {localStorage.getItem('companyName')} collects, retains and puts to use the information shared by the User, as above, with the consent of and concurrence of the User. The data and information collected above is utilized by {localStorage.getItem('companyName')}, to ensure effective rendering of its {localStorage.getItem('companyName')} Services and to comply with legal requirements.
          </Typography>
          <Typography paragraph>
            (B) {localStorage.getItem('companyName')} does not sell the data collected and retained of User.
          </Typography>
          <Typography paragraph>
            (C) Data collected from User is put to use by {localStorage.getItem('companyName')} for enhancing its services to User.
          </Typography>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Typography variant="h5" component="h3" gutterBottom>
          COLLECTION OF DATA
        </Typography>
        <Box sx={{ mb: 4 }}>
          <Typography variant="subtitle1" gutterBottom>
            <strong>(A) Cookies</strong>
          </Typography>
          <Typography paragraph>
            i. {localStorage.getItem('companyName')} uses cookies on its App and website to collect data about User. Cookies collect User information including App usage, visits to the App or website and other User generated information. Cookies allow Users to navigate from page to page without having to re-login each time, count visits, and see which areas and features of the {localStorage.getItem('companyName')} App and website are popular.
          </Typography>
          <Typography paragraph>
            ii. {localStorage.getItem('companyName')} may also use the data collected via cookies to tailor advertisements to Users and to track the popularity of its website. Use of cookies and other technologies may allow {localStorage.getItem('companyName')} and third parties to collect information about User browsing activities over time and across different websites following use of {localStorage.getItem('companyName')} services.
          </Typography>
          <Typography paragraph>
            iii. {localStorage.getItem('companyName')} also collects information that your browser sends whenever User visits its site. This information may include information such as the device's Internet Protocol ("IP") address (with replaced last byte), browser type, browser version, the pages of {localStorage.getItem('companyName')} site that User visits, the time and date of visit, the time spent on those pages and other statistics.
          </Typography>

          <Typography variant="subtitle1" gutterBottom sx={{ mt: 3 }}>
            <strong>(B) Analytics</strong>
          </Typography>
          <Typography paragraph>
            i. {localStorage.getItem('companyName')} uses third party analytical tools to collect data about User devices and Internet connections. That information includes the IP address of User computer and/or Internet service provider, when User accesses its website, the Internet address of websites from which User links to the {localStorage.getItem('companyName')} website, specifications of User browser, and User movements and preferences on the {localStorage.getItem('companyName')} website. All of this information is used internally for the purpose of understanding how the {localStorage.getItem('companyName')} website is being used and to improve the same.
          </Typography>
          <Typography paragraph>
            ii. {localStorage.getItem('companyName')} also uses third party analytical tools to collect data about usage of the {localStorage.getItem('companyName')} mobile app. The information collected identifies the types and timing of actions taken, including installation, registration, uploading, and certain types of navigation. All of this information is used internally for the purpose of understanding how the {localStorage.getItem('companyName')} mobile app is being used and to improve the same
          </Typography>

          <Typography variant="subtitle1" gutterBottom sx={{ mt: 3 }}>
            <strong>(C) Action Tags</strong>
          </Typography>
          <Typography paragraph>
            i. {localStorage.getItem('companyName')} uses action tags (also called pixel tags, clear GIF, or beacons) to identify pages visited and interacted with by the User. Action tags may collect and transmit this data in a manner that identifies the User if User has registered with the {localStorage.getItem('companyName')} website, or is logged into the {localStorage.getItem('companyName')} website. {localStorage.getItem('companyName')} also uses action tags in emails, to determine whether an email has been opened or whether it has been forwarded to a third party.
          </Typography>
          <Typography paragraph>
            ii. {localStorage.getItem('companyName')} also uses action tags in the mobile app which may identify the websites visited by the User and the manner in which the User interacts with them.
          </Typography>

          <Typography variant="subtitle1" gutterBottom sx={{ mt: 3 }}>
            <strong>(D) Do Not Track</strong>
          </Typography>
          <Typography paragraph>
            {localStorage.getItem('companyName')} currently does not respond to "Do Not Track" signals and operates as described in this Privacy Policy whether or not a Do Not Track signal is received. If there is a change in such policy, a suitable modification to this Privacy Policy will be made by {localStorage.getItem('companyName')} listing out the mechanism and procedure for the same.
          </Typography>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Typography variant="h5" component="h3" gutterBottom>
          GRIEVANCE
        </Typography>
        <Box sx={{ mb: 4 }}>
          <Typography paragraph>
            User may register their grievance with respect to data collection, retention or use to {localStorage.getItem('companyName')}'s Grievance Officer via contact form in <a href={localStorage.getItem('brokerDomain')} target="_blank" rel="noopener noreferrer">{localStorage.getItem('brokerDomain')}</a>
          </Typography>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Typography variant="h5" component="h3" gutterBottom>
          DATA RETENTION
        </Typography>
        <Box sx={{ mb: 4 }}>
          <Typography paragraph>
            (A) {localStorage.getItem('companyName')} shall retain the User's information for as long as the account is active or as needed to provide services in accordance with applicable laws.
          </Typography>
          <Typography paragraph>
            (B) The retention period may be extended to comply with legal obligations, resolve disputes, and enforce agreements for a period of ten years after termination of the account or such extended period, under applicable laws. {localStorage.getItem('companyName')} may retain data for such or further periods but is not obligated to do so in all instances. {localStorage.getItem('companyName')} shall not be liable or responsible for non – availability or non – retention of data or information beyond the termination of the User account.
          </Typography>
          <Typography paragraph>
            (C) The retention period may extend beyond the end of User account, but it will be only as long as it is necessary for {localStorage.getItem('companyName')} to have sufficient information to respond to any issues that may arise later, including but not limited to retention for the purpose of investigations or ongoing prosecutions or in case of Suspicious transactions or if {localStorage.getItem('companyName')} requires the information for its records or to support legal proceedings, or if {localStorage.getItem('companyName')} believes in good faith that a law, regulation, rule or guideline requires it.
          </Typography>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Typography variant="h5" component="h3" gutterBottom>
          DATA DELETION PROCEDURE
        </Typography>
        <Box sx={{ mb: 4 }}>
          <Typography paragraph>
            (A) PERSONAL DATA: Retained only as long as necessary to fulfill the purposes for which it was collected or as required by law. Once the retention period ends, personal data is securely deleted.
          </Typography>
          <Typography paragraph>
            (B) FINANCIAL DATA: Retained as required by applicable financial and tax regulations. Once the retention period ends, financial data is securely deleted.
          </Typography>
          <Typography paragraph>
            (C) OPERATIONAL DATA: Retained for a reasonable period to support business operations. Once it is no longer needed, operational data is securely deleted.
          </Typography>
          <Typography paragraph>
            (D) LEGAL/COMPLIANCE DATA: Retained for the duration specified by applicable laws or regulations. Once the retention period ends, legal/compliance data is securely deleted.
          </Typography>
          <Typography paragraph>
            (E) Data deletion involves the secure and irreversible removal of data from all relevant storage locations. The procedures for data deletion include:
          </Typography>
          <List dense sx={{ pl: 4 }}>
            <ListItem>
              <ListItemText primary="(a) Identifying data to be deleted based on the data retention periods." />
            </ListItem>
            <ListItem>
              <ListItemText primary="(b) Verifying the deletion request and obtaining necessary approvals." />
            </ListItem>
            <ListItem>
              <ListItemText primary="(c) Using appropriate methods and tools to securely delete data." />
            </ListItem>
            <ListItem>
              <ListItemText primary="(d) Documenting the deletion process for audit and compliance purposes." />
            </ListItem>
            <ListItem>
              <ListItemText primary={`(e) Customers may request complete deletion of their data by using the “Delete my data” button in the Settings of the ${localStorage.getItem('companyName')} interface. Upon using this feature, the customer’s data goes immediately to the deletion queue from where it is automatically and permanently deleted at the end of the retention period.`} />
            </ListItem>
          </List>
          <Box sx={{ mt: 2, textAlign: 'left' }}>
            <Button
              variant="contained"
              color="primary"
              href={window.location.origin + '/settings'}
              target="_blank"
              rel="noopener noreferrer"
            >
              Request for data deletion
            </Button>
          </Box>
        </Box>
        

        <Divider sx={{ my: 4 }} />

        <Typography variant="h5" component="h3" gutterBottom>
          UPDATION OF USER DATA AND WITHDRAWAL OF USER CONSENT
        </Typography>
        <Box sx={{ mb: 4 }}>
          <Typography paragraph>
            (A) The User shall ensure that all data and information shared with {localStorage.getItem('companyName')} is accurate, correct and complete. User shall ensure that change of the User's address or any change in circumstances impacting use of the {localStorage.getItem('companyName')} Services, is promptly communicated to {localStorage.getItem('companyName')} through contact form at <a href={localStorage.getItem('brokerDomain')} target="_blank" rel="noopener noreferrer">{localStorage.getItem('brokerDomain')}</a>.
          </Typography>
          <Typography paragraph>
            (B) {localStorage.getItem('companyName')} will not be held liable or responsible for any incorrect information provided by the User to {localStorage.getItem('companyName')}.
          </Typography>
          <Typography paragraph>
            (C) User may, upon termination of the use of the {localStorage.getItem('companyName')} Services, as provided in the Terms of Service, withdraw consent granted herein to {localStorage.getItem('companyName')}. The same shall however not affect actions undertaken or data and information collated or technological processes initiated prior to such withdrawal of consent. Such withdrawal of consent shall also not affect retention of data and information collected prior to such withdrawal.
          </Typography>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Typography variant="h5" component="h3" gutterBottom>
          SHARING OF INFORMATION WITH THIRD-PARTIES
        </Typography>
        <Box sx={{ mb: 4 }}>
          <Typography paragraph>
            The User agrees and consents to {localStorage.getItem('companyName')} sharing the following anonymized data or to otherwise give {localStorage.getItem('companyName')} permission to share with third-parties the following:
          </Typography>
          <Typography paragraph>
            (A) For advertising, referral, operations, financial services and technology services (such as hosting providers, identity verification, support, payment, and email service providers);
          </Typography>
          <Typography paragraph>
            (B) If required by applicable law or legal process, or if {localStorage.getItem('companyName')} believes that it is in accordance with applicable law or legal process;
          </Typography>
          <Typography paragraph>
            (C) To protect the rights, property and safety of {localStorage.getItem('companyName')}, its users and the public, including, including but not limited to usage in court proceedings, or to detect or prevent criminal activity, fraud, material misrepresentation, or to establish its rights or defend against legal claims; or
          </Typography>
          <Typography paragraph>
            (D) In connection with selling, merging, transferring, or reorganizing all or parts of {localStorage.getItem('companyName')}'s business.
          </Typography>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Typography variant="h5" component="h3" gutterBottom>
          REASONABLE SECURITY PRACTICES
        </Typography>
        <Box sx={{ mb: 4 }}>
          <Typography paragraph>
            (A) Protection of the User's personal information is of utmost importance to {localStorage.getItem('companyName')} and it takes all reasonable steps to secure data and information pertaining to its Users, including those prescribed under all applicable laws
          </Typography>
          <Typography paragraph>
            (B) {localStorage.getItem('companyName')} takes appropriate legal, administrative, physical, and electronic measures designed to protect the information that Users share with {localStorage.getItem('companyName')} from accidental or unlawful destruction, accidental loss or unauthorized access, use, modification, interference, or disclosure.
          </Typography>
          <Typography paragraph>
            (C) {localStorage.getItem('companyName')} however does not extend any warranties with respect to the security or safety of data and information transmitted through digital platforms or online, both of which are susceptible to malicious attacks.
          </Typography>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Typography variant="h5" component="h3" gutterBottom>
          MODIFICATIONS
        </Typography>
        <Box sx={{ mb: 4 }}>
          <Typography paragraph>
            These terms may be periodically reviewed and revised. User will be notified through an update of the App. The revised draft will be uploaded on the {localStorage.getItem('companyName')} Website and will reflect the modified date of the terms. User is required to periodically visit the website and review terms and any changes thereto. Continued use of the {localStorage.getItem('companyName')} Services constitutes agreement of User to the terms contained herein and any amendments thereto.
          </Typography>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Typography variant="h5" component="h3" gutterBottom>
          MISCELLANEOUS
        </Typography>
        <Box sx={{ mb: 4 }}>
          <Typography paragraph>
            All other provisions of the {localStorage.getItem('companyName')} Terms of Service shall be read into this policy and shall form part hereof, including Governing Laws and jurisdiction, notices, severability, assignment and such or other provisions.
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default PrivacyPolicy;